import React from "react";
import { ReactComponent as VoiceIcon } from "../images/voice-icon.svg";
import { ReactComponent as ChatIcon } from "../images/chat-icon.svg";
import { Message } from "../types/types";

type Props = {
  messages: Message[];
  inputValue: string;
  setInputValue: (val: string) => void;
  onSubmit: (message?: string) => void;
  isDisabled?: boolean;
  isSubmitted?: boolean;
};

const ChatInput: React.FC<Props> = ({
  inputValue,
  setInputValue,
  onSubmit,
  messages,
  isDisabled = false,
  isSubmitted = false,
}) => {
  const handleSubmit = () => {
    if (!isDisabled && inputValue.trim()) {
      onSubmit(inputValue.trim());
    }
  };

  return (
    <div
      className={`iris-input-wrapper ${
        isSubmitted ? "iris-input-wrapper--bottom" : ""
      }`}
    >
      <input
        type="text"
        placeholder={
          isDisabled
            ? "Please wait for the bot to respond..."
            : "How can I help?"
        }
        className="iris-input"
        value={inputValue}
        onChange={(e) => !isDisabled && setInputValue(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter" && !isDisabled) {
            e.preventDefault();
            handleSubmit();
          }
        }}
        disabled={isDisabled}
      />
      <button
        className="iris-mic-button"
        onClick={handleSubmit}
        disabled={isDisabled || !inputValue.trim()}
      >
        {inputValue.trim() === "" ? <VoiceIcon /> : <ChatIcon />}
      </button>
    </div>
  );
};

export default ChatInput;
